import {useEffect, useMemo} from 'react';
import {useReservation} from 'context/reservation';
import {
  useFaceModelsStore,
  usePreloadFaceModels,
  canUseClientSideDetection,
} from '@chekin/shared';

export const LivenessModelPreloader = () => {
  const {housing} = useReservation();
  const setIsWebGLSupported = useFaceModelsStore(state => state.setIsWebGLSupported);
  const forceLivenessMechanism = housing?.force_liveness_mechanism || 'AUTO';

  const isDeviceCapable = useMemo(() => {
    if (forceLivenessMechanism === 'SERVER') {
      return false;
    }

    if (forceLivenessMechanism === 'CLIENT') {
      return true;
    }

    return canUseClientSideDetection({
      setIsWebGLSupported,
    });
  }, [setIsWebGLSupported, forceLivenessMechanism]);

  const {preload} = usePreloadFaceModels();

  useEffect(() => {
    if (!housing?.id || !isDeviceCapable || forceLivenessMechanism === 'SERVER') {
      return;
    }

    if (housing.is_liveness_detection_enabled) {
      void preload();
    }
  }, [
    preload,
    housing?.id,
    isDeviceCapable,
    forceLivenessMechanism,
    housing?.is_liveness_detection_enabled,
  ]);

  return null;
};
